module.exports = __webpack_public_path__ + "static/media/38_A.086b3a57.png";